import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { SubCategoryFieldConfig } from "./entity";

const createCustomFilter = createCustomFilterForEntity<SubCategoryFieldConfig>();

export class SubCategoryFieldConfigFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<SubCategoryFieldConfig>
  >((filters) => {
    return filterWithRelationsAndJson(SubCategoryFieldConfig)(filters);
  });
}
